import { useState } from "react";
import { AlarmClock, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { setCallback } from "../lib/api";
import { callbackState, fmtDateTime } from "../lib/callback";

const TAG = {
  overdue: { label: "Overdue", cls: "bg-red-950/60 text-red-300 border-red-600/60" },
  today: { label: "Due today", cls: "bg-amber-950/60 text-amber-300 border-amber-500/60" },
  upcoming: { label: "Scheduled", cls: "bg-slate-800 text-slate-300 border-slate-600" },
};

export const CallbackReminder = ({ lead, onUpdated }) => {
  const [value, setValue] = useState("");
  const [busy, setBusy] = useState(false);
  const state = callbackState(lead.callback_at);

  const save = async (iso) => {
    setBusy(true);
    try {
      await setCallback(lead.id, iso);
      setValue("");
      onUpdated();
    } catch (e) {
      toast.error(e?.response?.data?.detail?.toString() || "Could not save callback");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-3" data-testid={`lead-callback-${lead.id}`}>
      <label className="font-mono text-[10px] uppercase tracking-widest text-slate-500 flex items-center gap-1 mb-1">
        <AlarmClock className="h-3 w-3" /> Callback
      </label>
      {state ? (
        <div className="flex items-center gap-2 flex-wrap">
          <span data-testid={`lead-callback-tag-${lead.id}`} className={`text-[10px] font-mono font-bold uppercase tracking-wider px-2 py-0.5 rounded-sm border ${TAG[state].cls}`}>
            {TAG[state].label}
          </span>
          <span data-testid={`lead-callback-time-${lead.id}`} className="text-xs text-white font-mono">{fmtDateTime(lead.callback_at)}</span>
          <button data-testid={`lead-callback-clear-btn-${lead.id}`} onClick={() => save(null)} disabled={busy} title="Clear callback"
            className="p-1 rounded border border-[#262C38] text-slate-400 hover:text-white hover:border-slate-400 disabled:opacity-50">
            {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <X className="h-3 w-3" />}
          </button>
        </div>
      ) : (
        <div className="flex gap-2">
          <input data-testid={`lead-callback-input-${lead.id}`} type="datetime-local" value={value} onChange={(e) => setValue(e.target.value)}
            className="flex-1 min-w-0 bg-[#0B0C0E] border border-[#262C38] rounded px-3 py-2 text-xs text-white focus:outline-none focus:border-[#F95722] [color-scheme:dark]" />
          <button data-testid={`lead-callback-save-btn-${lead.id}`} onClick={() => save(new Date(value).toISOString())} disabled={busy || !value}
            className="inline-flex items-center gap-1 bg-[#181C24] border border-[#384152] hover:border-[#F95722] text-white px-3 py-2 rounded text-xs font-bold disabled:opacity-50">
            {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : "Set"}
          </button>
        </div>
      )}
    </div>
  );
};
